import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>
  createStyles({
    hintText: {
      color: theme.palette.common.gray600,
    },
  }),
);
